import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h4",
    css: css`
        text-align: center;
        border: 1px solid #d8d8d8;
        padding-top: 20px;
        padding-bottom: 20px;
        background: #fbfbfb;
        margin-bottom: 0px;
    `,
};

signInExistingAccountStyles.signInGridContainer = {
    css: css`
        background: #fbfbfb;
        border: 1px solid #d8d8d8;
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 0px;
        height: 400px;
    `,
};

signInExistingAccountStyles.userNameGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    div[class^="FormFieldStyle"] {
                        padding: 0px 10px;
                    }
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    div[class^="FormFieldStyle"] {
                        padding: 0px 10px;
                    }
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    div[class^="FormFieldStyle"] {
                        padding: 0px 10px;
                    }
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    div[class^="FormFieldStyle"] {
                        padding: 0px 10px;
                    }
                `,
                css`color:#333333    
            flex-basis: 60%;
            max-width: 60%;
            margin: auto !important;
            input[type="text"]{
                background: #F5F5F5;
                border: 1px solid #D1D1E6;
            }`,
            ])}
    `,
};

signInExistingAccountStyles.passwordGridItem = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        div[class^="FormFieldStyle"] {
                            padding: 0px 10px;
                        }
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        div[class^="FormFieldStyle"] {
                            padding: 0px 10px;
                        }
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        div[class^="FormFieldStyle"] {
                            padding: 0px 10px;
                        }
                    `,
                    css`
                        width: 100%;
                        flex: 100%;
                        max-width: 100%;
                        div[class^="FormFieldStyle"] {
                            padding: 0px 10px;
                        }
                    `,
                    css`
                        color: #333333;
                        flex-basis: 60%;
                        max-width: 60%;
                        margin: auto !important;
                        input[type="password"] {
                            background: #f5f5f5;
                            border: 1px solid #d1d1e6;
                        }
                    `,
                ],
                "minMax",
            )}
    `,
};

(signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        button {
            margin: auto;
            width: 58%;
            text-transform: uppercase;
        }
    `,
    // eslint-disable-next-line no-sequences
}),
    (signInExistingAccountStyles.signInButton = {
        variant: "secondary",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    }),
    (signInExistingAccountStyles.rememberMeGridItem = {
        width: 6,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: relative;
                            left: 15px;
                            label {
                                font-size: 13px;
                                font-weight: 600;
                            }
                        `,
                        css`
                            position: relative;
                            left: 15px;
                            label {
                                font-size: 13px;
                                font-weight: 600;
                            }
                        `,
                        css`
                            position: relative;
                            left: 15px;
                            label {
                                font-size: 13px;
                                font-weight: 600;
                            }
                        `,
                        css`
                            position: relative;
                            left: 15px;
                            label {
                                font-size: 13px;
                                font-weight: 600;
                            }
                        `,
                        css`
                            position: relative;
                            left: 135px;
                            label {
                                color: #333333;
                                font-weight: bold;
                                font-size: 13px;
                            }
                        `,
                    ],
                    "minMax",
                )}
        `,
    }),
    (signInExistingAccountStyles.forgotPasswordGridItem = {
        width: 6,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            color: #3465b1;
                            font-size: 13px;
                            font-weight: bold;
                            position: relative;
                            left: 25px;
                        }
                    `,
                    css`
                        span {
                            color: #3465b1;
                            font-size: 13px;
                            font-weight: bold;
                            position: relative;
                            left: 25px;
                        }
                    `,
                    css`
                        span {
                            color: #3465b1;
                            font-size: 13px;
                            font-weight: bold;
                            position: relative;
                            left: 232px;
                        }
                    `,
                    css`
                        span {
                            color: #3465b1;
                            font-size: 13px;
                            font-weight: bold;
                            position: relative;
                            left: 90%;
                        }
                    `,
                    css`
                        justify-content: center;
                        span {
                            color: #3465b1;
                            font-size: 13px;
                            font-weight: bold;
                            position: relative;
                            right: 37px;
                        }
                    `,
                ])}
        `,
    });
